document.addEventListener('DOMContentLoaded', () => {
    const badgeId = 'trustbadge-container-98e3dadd90eb493088abdc5597a70810';

    const interval = setInterval(() => {
        const badge = document.getElementById(badgeId);
        if (!badge) {
            return;
        }
        clearInterval(interval);

        function updateBadgeVisibility() {
            if (window.scrollY === 0) {
                badge.style.display = 'block';
                badge.style.opacity = '1';
            } else {
                badge.style.display = 'none';
                badge.style.opacity = '0';
            }
        }

        window.addEventListener('scroll', () => requestAnimationFrame(updateBadgeVisibility));
        updateBadgeVisibility();

        // Hide badge when menu drawer opens; restore on close
        let drawerWasOpen = false;
        new MutationObserver(() => {
            const drawerIsOpen = Array.from(document.body.classList).some((cls) =>
                cls.startsWith('overflow-hidden')
            );
            if (drawerIsOpen !== drawerWasOpen) {
                if (drawerIsOpen) {
                    badge.style.display = 'none';
                    badge.style.opacity = '0';
                } else {
                    // Small delay to let iOS restore scroll position before checking
                    setTimeout(() => requestAnimationFrame(updateBadgeVisibility), 50);
                }
                drawerWasOpen = drawerIsOpen;
            }
        }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }, 100);
});
